import { h } from 'preact';
import { useState } from 'preact/hooks';

interface FixedImageProps {
  src: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  top?: number | string;
  style?: preact.JSX.CSSProperties;
}

export function FixedImage({
  src,
  alt = '',
  width = 120,
  height = 120,
  top = '-60px',
  style = {}
}: FixedImageProps) {
  const [imgError, setImgError] = useState(false);
  if (imgError) {
    return null;
  }
  return (
    <div
      style={{
        position: 'absolute',
        top,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        width,
        height,
        ...style
      }}
    >
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
        onError={() => setImgError(true)}
      />
    </div>
  );
}
